import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './llc-mortgage.actions';

@Injectable({
	providedIn: 'root',
})
export class LLCMortgageDispatch {
	@Dispatch()
	UpdateAll = (force: boolean): actions.UpdateAll =>
		new actions.UpdateAll(force);

	@Dispatch()
	UpdateTransaction = (transactionId: string): actions.UpdateStatus =>
		new actions.UpdateStatus(transactionId);

	@Dispatch()
	LockUserAccess = (transactionId: string): actions.LockUserAccess =>
		new actions.LockUserAccess(transactionId);

	@Dispatch()
	UnlockUserAccess = (transactionId: string): actions.LockUserAccess =>
		new actions.UnlockUserAccess(transactionId);

	@Dispatch()
	UpdateTimestamp = (transactionId: string): actions.UpdateTimestamp =>
		new actions.UpdateTimestamp(transactionId);
}
